import termsOfService from "./terms-of-service.md";
import privacyPolicy from "./privacy-policy.md";
import eula from "./eula.md";

export type LegalDocumentKey = "terms" | "privacy" | "eula";

export interface LegalDocument {
    title: string;
    path: string;
    content: string;
}

export const legalDocuments: Record<LegalDocumentKey, LegalDocument> = {
    terms: {
        title: "Terms of Service",
        path: "/terms",
        content: termsOfService,
    },
    privacy: {
        title: "Privacy Policy",
        path: "/privacy",
        content: privacyPolicy,
    },
    eula: {
        title: "End User License Agreement",
        path: "/eula",
        content: eula,
    },
};
